import React from 'react'
import Header from '../components/header'
import Footer from '../components/footer'
import barcode from '../W-barcode.jpeg'
import counter from '../W-counter.jpeg'
import fileConverter from '../W-FileConverter.jpeg'
import QR from '../W-QR.jpeg'
import TextSpeech from '../W-TextSpeech.jpeg'
import GuestPost from '../W-GuestPosts.png'
import ImageGen from '../W-ImageGen.png'
import QuizGenerator from '../W-quizGenerator.png'
import yt from '../W-yt.jpeg'
import SubBlogs from '../components/subCmponents/subBlogs'
import { Helmet } from 'react-helmet'

export default function Blogs() {

  let allBlogs = [
    { id: "9", name: "Affordable Guest Post Services in the USA & UK for High-Authority SEO Backlinks", image: GuestPost },
    { id: "8", name: "ImageGen AI: The Ultimate Free AI Image Generator Online in 2026", image: ImageGen },
    { id: "7", name: "AI Quiz Generator: Create Smart Quizzes Instantly Using Artificial Intelligence", image: QuizGenerator },
    { id: "1", name: "Free QR Code Generator Online – Instantly Create Custom QR Codes", image: QR },
    { id: "2", name: "Word Counter – Instantly Count Words, Characters & More Online", image: counter },
    { id: "3", name: "Free YouTube Thumbnail Downloader – Save HD Thumbnails Instantly", image: yt },
    { id: "4", name: "Free Online Barcode Scanner – Scan Barcodes Instantly with Your Camera", image: barcode },
    { id: "5", name: "Free Online File Converter – Convert Documents, Images & More with One Click", image: fileConverter },
    { id: "6", name: "Free Online Text to Speech Converter – Turn Text Into Natural Voice Instantly", image: TextSpeech },
  ]

  return (
    <div>
      <Helmet>
        <html lang="en" />
        <title>Tooliso Blogs – Online Tools Tips, Tutorials & Product Updates</title>
        <meta
          name="description"
          content="Explore Tooliso’s latest blog posts. Learn how to use free online tools like QR generators, word counters, file converters, and more."
        />
        <meta property="og:title" content="Tooliso Blog – Tips & Tricks for Online Tools" />
        <meta property="og:description" content="Discover how to use Tooliso's online utilities efficiently. Stay updated with tutorials, tips, and new feature releases." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.tooliso.com/Blogs" />
        <meta property="og:image" content="https://www.tooliso.com/blogs-og.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Tooliso Blogs – Helpful Guides for Digital Tools" />
        <meta name="twitter:description" content="Learn how to get the most out of Tooliso’s free online tools. Read guides, how-tos, and expert advice on our blog." />
        <meta name="twitter:image" content="https://www.tooliso.com/twitter-blogs.jpg" />
      </Helmet>

      <Header />
      <div className="blogs-page">
        <h1 className="blogs-title">Latest Blogs</h1>
        <div className="blogs-container">
          {allBlogs.map((single, i) => (
            <SubBlogs key={i} name={single.name} image={single.image} id={single.id} />
          ))}
        </div>
      </div>
      <Footer />
    </div>
  )
}